var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerchandiseEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M205.915 99.1606H202.789L176.375 72.7466C174.265 70.6366 170.826 70.6366 168.638 72.7466C166.528 74.8566 166.528 78.2951 168.638 80.4832L187.316 99.1606H111.356L130.033 80.4832C132.143 78.3732 132.143 74.9347 130.033 72.7466C127.923 70.6366 124.485 70.6366 122.296 72.7466L95.9605 99.1606H92.8345C85.8012 99.1606 71.1875 99.1606 71.1875 119.167C71.1875 126.747 72.7505 131.748 76.0327 135.031C77.9082 136.985 80.1745 138.001 82.5971 138.548C84.8634 139.095 87.286 139.173 89.6305 139.173H209.041C211.463 139.173 213.73 139.017 215.918 138.548C222.482 136.985 227.484 132.295 227.484 119.167C227.484 99.1606 212.87 99.1606 205.915 99.1606Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.123 139.172H89.6349C87.3686 139.172 84.8679 139.094 82.6016 138.469L92.4482 198.565C94.6364 212.006 100.497 227.479 126.521 227.479H170.362C196.698 227.479 201.386 214.272 204.2 199.502L216 138.469C213.812 139.016 211.468 139.172 209.123 139.172ZM149.34 200.128C131.053 200.128 116.127 185.201 116.127 166.915C116.127 163.711 118.784 161.054 121.988 161.054C125.192 161.054 127.849 163.711 127.849 166.915C127.849 178.793 137.461 188.405 149.34 188.405C161.218 188.405 170.831 178.793 170.831 166.915C170.831 163.711 173.488 161.054 176.692 161.054C179.896 161.054 182.553 163.711 182.553 166.915C182.553 185.201 167.626 200.128 149.34 200.128Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchandiseEmpty);
export default __webpack_public_path__ + "static/media/merchandiseEmpty.1957aaa2c0da1d25a9124ddcd256bda1.svg";
export { ForwardRef as ReactComponent };